export default "__VITE_ASSET__0470b19b__"